import {
  REQUIRABLE_RESIDENT_FIELDS,
  type RequirableResidentField,
  type AccountStatusId,
  type UnsavedAccountStatus,
  type WithAccountStatusId,
  type RequiredAccountField,
  type AccountStatusData,
} from '../model'
import { filterArchived } from './common'
import { isEmpty } from './isEmpty'

type Status = Pick<UnsavedAccountStatus, 'order'> & Partial<Pick<UnsavedAccountStatus, 'name'>>

export function sortAccountStatuses<T extends Status>(statuses: T[]): T[] {
  return statuses.sort(({ order: a, name: aName }, { order: b, name: bName }) => {
    if (a !== b) return (a ?? 0) - (b ?? 0)
    if (!aName || !bName) return 0
    return aName.localeCompare(bName)
  })
}

export function toAccountStatusId(data: WithAccountStatusId): AccountStatusId {
  return data.statusId
}

export function isRequirableResidentField(field: RequiredAccountField): field is RequirableResidentField {
  return REQUIRABLE_RESIDENT_FIELDS.some((f) => f === field)
}

export function findInitialStatus<T extends Pick<AccountStatusData, 'order' | 'isDeleted'>>(
  statuses: T[]
): T | undefined {
  const getOrder = (status: T): number => {
    if (isEmpty(status.order)) return Infinity
    if (typeof status.order !== 'number') return Infinity
    return status.order
  }
  return filterArchived(statuses)
    .sort((a, b) => getOrder(a) - getOrder(b))
    .at(0)
}

export function getInitialStatus(statuses: AccountStatusData[]): AccountStatusData {
  const status = findInitialStatus(statuses)
  if (status) return status
  throw new Error('No initial status found')
}
